
(() => {
  if (window.accessoryCartInitialized) return;
  window.accessoryCartInitialized = true;

  // ADD ACCESSORY TO CART
  document.addEventListener('click', async function(event) {
    const button = event.target.closest('.add-extra-product');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.disabled) return;

    const card = button.closest('.additional-item-card');
    if (!card) return;

    const select = card.querySelector('[data-extra-item-variant]');
    const variantInput = card.querySelector('[data-extra-item-selected-variant]');
    const variantId = select?.value || variantInput?.value;

    if (!variantId || (select && select.disabled)) {
      button.textContent = 'Unavailable';
      return;
    }

    const originalText = 'Add';
    button.disabled = true;
    button.textContent = 'Adding...';

    let addedSuccessfully = false;

    try {
      const cartNotification = document.querySelector('cart-notification');

      // Use the same FormData format as the main product form.
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (cartNotification) {
        formData.append(
          'sections',
          cartNotification.getSectionsToRender().map(s => s.id).join(',')
        );
        formData.append('sections_url', window.location.pathname);
      }

      const response = await fetch(
        window.routes?.cart_add_url || '/cart/add',
        {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: formData
        }
      );

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(
          result.description || result.message || 'Could not add accessory'
        );
      }

      // The item has successfully been added.
      addedSuccessfully = true;
      button.textContent = 'Added ✓';

      // Render the notification separately.
      if (cartNotification && result.sections) {
        try {
          cartNotification.setActiveElement(button);
          cartNotification.renderContents(result);
        } catch (notificationError) {
          console.warn(
            'Cart notification could not render:',
            notificationError
          );
        }
      }

      // Update cart bubble independently if needed.
      try {
        const bubbleHTML = result.sections?.['cart-icon-bubble'];

        if (bubbleHTML) {
          const parsed = new DOMParser().parseFromString(
            bubbleHTML,
            'text/html'
          );

          const newBubble = parsed.querySelector('#cart-icon-bubble');
          const oldBubble = document.querySelector('#cart-icon-bubble');

          if (newBubble && oldBubble) {
            oldBubble.replaceWith(newBubble);
          }
        }
      } catch (bubbleError) {
        console.warn('Cart bubble update failed:', bubbleError);
      }

    } catch (error) {
      console.error('Accessory cart error:', error);

      if (!addedSuccessfully) {
        button.textContent = 'Error - Retry';
      }

    } finally {
      button.disabled = false;
    }
  });

  // UPDATE ACCESSORY WHEN VARIANT CHANGES
  document.addEventListener('change', function(event) {
    const select = event.target.closest('[data-extra-item-variant]');
    if (!select) return;

    const card = select.closest('.additional-item-card');
    if (!card) return;

    const option = select.options[select.selectedIndex];
    const button = card.querySelector('.add-extra-product');
    const variantInput = card.querySelector(
      '[data-extra-item-selected-variant]'
    );

    const image = card.querySelector('[data-extra-img]');
    const price = card.querySelector('[data-extra-price]');
    const description = card.querySelector('[data-extra-desc]');

    if (variantInput) {
      variantInput.value = select.value;
    }

    const imgUrl = option?.getAttribute('data-var-img');
    if (image && imgUrl) image.src = imgUrl;

    if (price) {
      price.textContent = option?.getAttribute('data-var-price') || '';
    }

    if (description) {
      description.textContent =
        option?.getAttribute('data-var-desc') || '';
    }

    if (button) {
      button.textContent = 'Add';
    }
  });
})();
